<div class="scrollable-wrapper" [class.scrollable-wrapper--active]="enabled()">

  <div class="scrollable-content" [class.scrollable-content--active]="enabled()"
       #scrollContent (scroll)="onScroll()">
    <ng-content></ng-content>
  </div>

  @if (enabled() && showScrollbar) {
    <div class="scrollable-track" #scrollTrack (click)="onTrackClick($event)">
      <div
        class="scrollable-thumb"
        [style.height.px]="thumbHeight"
        [style.top.px]="thumbTop"
        (mousedown)="onThumbMouseDown($event)">
      </div>
    </div>
  }

</div>
